import React, { useState, useLayoutEffect, useCallback, useEffect } from 'react'
import { Link, useLocation } from 'react-router'
import { Menu } from "@headlessui/react";
import user_model from 'models/user_model'
import { useUser } from 'xAppLib/Hooks'

const AdminMenu = ({ level = 0, inSideMenu = false, isRight, isEnter, closeMenu }) => {
	const user = useUser()
	const location = useLocation()
	const curr_page = location.pathname
	const [activeSubMenu, setActiveSubMenu] = useState()
	const [previousActive, setPreviousActive] = useState()
	const [displays, setDisplays] = useState({})
	const [activePosition, setActivePosition] = useState()
	const [adminPosition, setAdminPosition] = useState()

	const notActive = {
		display: 'none',
	}

	const isActive = {
		display: 'block',
		position: 'absolute',
		backgroundColor: 'white',
		zIndex: '50',
		boxShadow: '0px 1px 3px 0px rgb(0 0 0 / 8%)',
		border: '1px solid rgba(34, 36, 38, 0.15)',
		minWidth: adminPosition?.width,
		top: activePosition?.bottom - adminPosition?.top - activePosition?.height - 1,
		left: isRight ? 'auto' : activePosition?.right - adminPosition?.left,
		right: isRight ? adminPosition?.width - 1 : 'auto',
		maxHeight: '80vh',
		overflowY: 'auto'
	}

	useEffect(() => {
		window.addEventListener('resize', deactiveSub)
		return (() => window.removeEventListener('resize', deactiveSub))
	}, [])

	useLayoutEffect(() => {
		setDisplays({...displays, [previousActive]: notActive, [activeSubMenu]: isActive })
	}, [activeSubMenu, previousActive])

	useLayoutEffect(() => {
		deactiveSub()
	}, [isEnter])

	const deactiveSub = useCallback(() => {
		setDisplays({...displays, [activeSubMenu]: notActive })
	}, [])

	const handleMouseOn = (e) => {
		setPreviousActive(activeSubMenu)
		setActivePosition(e.target.getBoundingClientRect())
		setAdminPosition(document.getElementsByClassName('admin-menu')[0].getBoundingClientRect())
		setActiveSubMenu(e.target.textContent)
	}

	if (!user.user_in)
		return null
	
	if (inSideMenu) 
		 return <Menu as="div" className="menu inverted fluid 
		 			px-6 lg:px-16 pt-11 pb-20 lg:py-11">
					{
						Object.keys(user_model.ROLE_LIST)
							.sort( (a,b)=>b-a )
							.map( (r,i) =>
										app.user.claims[user_model.ROLE_LIST[r].c] &&
										// r<=user_lev &&
										app.app_data.ws_conf.user_menus['menu_'+user_model.ROLE_LIST[r].c] &&
								<div key={'user_menu sub '+r}>
									<h3>{user_model.ROLE_LIST[r].n} menu</h3>
									<div className="admin-menu flex flex-col ml-0" style={{marginLeft:0}}>
									{
										app.app_data.ws_conf.user_menus['menu_'+user_model.ROLE_LIST[r].c] &&
											app.app_data.ws_conf.user_menus['menu_'+user_model.ROLE_LIST[r].c]
												.filter(item => !item.role || user_model.check_access(item.role))
												.filter((item) => {
													if (item.flag?.startsWith('booking')) {
														return !!app.site_status?.booking?.show_admin_menu;
													}
													return true;
												})
												.map( (p, i) => p.type=='separator' && <hr color='grey' key={'user_menu sub '+r+'-'+i} style={{margin:'.5em 0'}}/>
											|| p.type=='spacer' && <div key={'user_menu sub '+r+'-'+i} style={{lineHeight:.5}}>&nbsp;</div>
											|| (p.type=='header' || p.type=='subheader') && <div className="sub-header" icon={p.ico} key={'user_menu sub '+r+'-'+i}>{p.name}</div>
											|| p.u && p.name && <Menu.Item
															className="item justify-between w-full px-5 py-3"
															active={curr_page == p.u
																	|| curr_page
																		&& curr_page.startsWith(p.u + (p.u && p.u.endsWith('/') ? '' : '/'))
																}
															// active={curr_page === p.u}
															onClick={() => closeMenu?.()}
															as={Link}
															to={p.u}
															key={'user_menu sub '+r+'-'+i}
														 > {p.name} <i aria-hidden="true" className={`is-icon ${p.ico}`} /></Menu.Item>
													 || null
													)
									}
									</div>
								</div>
								|| null
							)
					}
				</Menu>
			
	return <React.Fragment>
				{
					Object.keys(user_model.ROLE_LIST)
						.sort( (a,b)=>b-a )
						.map( (r,i) => {
							let nestedMenu = []
							return  app.user.claims[user_model.ROLE_LIST[r].c] &&
							// r<=user_lev &&
							app.app_data.ws_conf.user_menus['menu_'+user_model.ROLE_LIST[r].c] &&
							<React.Fragment key={'user_menu sub '+r}>
								{/* <Menu.Header>{user_model.ROLE_LIST[r].n} menu</Menu.Header> */}
								{
									app.app_data.ws_conf.user_menus['menu_'+user_model.ROLE_LIST[r].c] &&
										app.app_data.ws_conf.user_menus['menu_'+user_model.ROLE_LIST[r].c]
											.filter(item => !item.role || user_model.check_access(item.role))
											.filter((item) => {
												if (item.flag?.startsWith('booking')) {
													return !!app.site_status?.booking?.show_admin_menu;
												}
												return true;
											})
											.filter(p=>p.name||p.type).map( (p, i) => {
												const menuLength = app.app_data.ws_conf.user_menus['menu_'+user_model.ROLE_LIST[r].c]
																	.filter(p=>p.name||p.type).length
												if (p.type === 'header' || i === menuLength - 1 ) {
													const renderMenu = nestedMenu;
													i === menuLength - 1 ? renderMenu.push(p) : nestedMenu = [p];
													if (renderMenu.length > 0) {
														renderMenu[renderMenu.length - 1].type === 'separator' && renderMenu.pop()
														const name = renderMenu[0].name
														!displays[name] && setDisplays({...displays, [name]: notActive})
														return <React.Fragment key={'user_menu '+r+'-'+i}>
															
															<button 
																className="item w-full flex px-4 py-2"
																onMouseEnter={handleMouseOn} 
																style={{justifyContent: isRight ? 'flex-end' : 'space-between', 
																		flexDirection: isRight ? 'row-reverse': 'row'}}>
																<div>{name}</div>
																<i aria-hidden='true' className={isRight?'caret left is-icon':'caret right is-icon'}/>
															</button>

															<div style={renderMenu[0].submenutop ? {...displays[name], top: renderMenu[0]['submenutop']} : displays[name]}>
																{renderMenu.shift() && renderMenu.map((sm, si) => 
																	sm.type === 'separator' && <hr color='grey' key={'user_menu sub '+r+'-'+ si} style={{margin:'.5em 0'}}/> ||
																	sm.type === 'spacer' && <div key={'user_menu sub '+r+'-'+si} style={{lineHeight:.5}}>&nbsp;</div> ||
																	sm.type === 'subheader' && <Menu.Item as="div" key={'user_menu sub '+r+'-'+si} className='sub-sub-header'><i aria-hidden="true" className={`is-icon ${sm.ico}`} />{sm.name}</Menu.Item> ||
																	<Menu.Item
																	className="item w-full flex"
																	active={curr_page == sm.u
																		|| curr_page
																			&& curr_page.startsWith(sm.u + (sm.u && sm.u.endsWith('/') ? '' : '/'))
																	}
																	as={Link}
																	to={sm.up ? { pathname: sm.u, state: sm.up } : sm.u}
																	key={'user_menu sub '+r+'-'+si}
																><i aria-hidden="true" className={`is-icon ${sm.ico}`} />
																{sm.name}</Menu.Item>)}
															</div>
														</React.Fragment>
													}
												} else {
													if (nestedMenu.length > 0)
														nestedMenu.push(p)
													else if (!p.type)
														return <Menu.Item
														active={curr_page == p.u
																|| curr_page
																	&& curr_page.startsWith(p.u + (p.u && p.u.endsWith('/') ? '' : '/'))
															}
														as={Link}
														to={p.up ? { pathname: p.u, state: p.up } : p.u}
														key={'user_menu sub '+r+'-'+i}
														><i aria-hidden="true" className={`is-icon ${p.ico}`} />{p.name}</Menu.Item>
												}			
											})	
								}

							</React.Fragment>
							|| null
						})
				}

			</React.Fragment>
		
}

AdminMenu.componentName = 'AdminMenu'
 
export default AdminMenu;
